import React from 'react';

const Sparkline = ({ data, width = 80, height = 20, color = '#3B82F6', strokeWidth = 2, minSpan = 0 }) => {
    if (!data || data.length === 0) return null;
    
    // Handle different data types
    let validData;
    let gustData = null;
    
    // Check if this is wind data with speed and gust properties
    if (data.length > 0 && typeof data[0] === 'object' && data[0].speed !== undefined) {
        // Wind data with speed and gust
        validData = data.map(d => d.speed).filter(d => d !== null && d !== undefined && !isNaN(d));
        gustData = data.map(d => d.gust).filter(d => d !== null && d !== undefined && !isNaN(d));
    } else {
        // Regular numeric data
        validData = data.filter(d => d !== null && d !== undefined && !isNaN(d));
    }
    
    if (validData.length < 2) return null;
    
    // Calculate min/max including gust data for wind
    let allValues = [...validData];
    if (gustData && gustData.length > 0) {
        allValues = [...allValues, ...gustData];
    }
    
    let min = Math.min(...allValues);
    let max = Math.max(...allValues);
    // minSpan: guarantee a minimum y-axis span so near-flat series render as
    // near-flat lines instead of dramatic full-height swings (e.g. pressure
    // drifting 0.3 hPa). Expands symmetrically around the data midpoint.
    if (minSpan > 0 && max - min < minSpan) {
        const mid = (max + min) / 2;
        min = mid - minSpan / 2;
        max = mid + minSpan / 2;
    }
    const range = max - min;
    
    // If all values are the same, show a flat line
    if (range === 0) {
        const y = height / 2;
        return (
            <svg width={width} height={height} className="inline-block">
                <line
                    x1={0}
                    y1={y}
                    x2={width}
                    y2={y}
                    stroke={color}
                    strokeWidth={strokeWidth}
                    fill="none"
                />
            </svg>
        );
    }
    
    // Create path points for wind speed
    const points = validData.map((value, index) => {
        const x = (index / (validData.length - 1)) * width;
        const y = height - ((value - min) / range) * height;
        return `${x},${y}`;
    }).join(' ');
    
    // Create path points for gusts if available
    let gustPoints = null;
    if (gustData && gustData.length > 0) {
        gustPoints = gustData.map((value, index) => {
            const x = (index / (gustData.length - 1)) * width;
            const y = height - ((value - min) / range) * height;
            return `${x},${y}`;
        }).join(' ');
    }
    
    return (
        <svg width={width} height={height} className="inline-block">
            {/* Main line (wind speed or regular data) */}
            <polyline
                points={points}
                stroke={color}
                strokeWidth={strokeWidth}
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Gust line for wind data */}
            {gustPoints && (
                <polyline
                    points={gustPoints}
                    stroke={color}
                    strokeWidth={strokeWidth * 0.8}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="2,2"
                    opacity="0.6"
                />
            )}
        </svg>
    );
};

export default Sparkline;